import React from 'react';
import Header from './Header';
import Footer from './Footer';

const TermsOfUse = () => {

  return (
     <>
      <div className="container">
        <h1>Terms of Use</h1>
        <p><strong>Effective Date:</strong> May 30, 2025</p>
        <p>These Terms of Use (“<strong>Terms</strong>”) govern your access to and use of services provided by <strong>Boggler (Private) Limited</strong> (“<strong>Boggler</strong>,” “<strong>we</strong>,” “<strong>us</strong>,” or “<strong>our</strong>”), including:</p>
        <ul>
          <li>The website at <strong>theboggler.com</strong> (the “<strong>Website</strong>”),</li>
          <li>Our mobile apps: <strong>Buckish</strong>, <strong>Apex</strong>, and <strong>Third View</strong> (collectively, the “<strong>Apps</strong>”),</li>
          <li>Interacting with our phone numbers or ShortCodes (collectively, “<strong>Hotlines</strong>”).</li>
        </ul>
        <p>By using our Website, Apps, or Hotlines you agree to these Terms. If you do not agree, please do not use our services.</p>

        <h2>1. Eligibility</h2>
        <p>You must be at least 13 years old to use our services. If you are under 18, you must have parental consent. By using our services, you confirm that you meet these requirements.</p>

        <h2>2. Description of Services</h2>
        <p>Boggler provides platforms that allow users to:</p>
        <ul>
          <li>Upload screenshots of journal entries, text messages, or social media posts,</li>
          <li>Select mentors (“guides”) to review and provide feedback,</li>
          <li>Subscribe and pay for services including guide reviews and ongoing support.</li>
        </ul>
        <p>Each App serves a different focus area but operates under these shared terms.</p>

        <h2>3. User Responsibilities</h2>
        <p>You agree to:</p>
        <ul>
          <li>Use the services only for lawful purposes;</li>
          <li>Not upload content that is illegal, harmful, or violates others' rights;</li>
          <li>Not impersonate others or misrepresent your identity;</li>
          <li>Not attempt to hack, disrupt, or reverse-engineer any part of our system;</li>
          <li>Not attempt to use our services for emergency purposes or to receive care in an emergency situation.</li>
        </ul>
        <p>You are solely responsible for the content you upload.</p>

        <h2>4. Payments</h2>
        <ul>
          <li><strong>Fees:</strong> Buckish, Third View, and other Boggler Apps require payment (e.g., 100 Rs or $4.99, depending on region).</li>
          <li><strong>Per-Review Payments:</strong> Additional fees apply per guide review (e.g., $1 international, $5 US-based standard, or custom pricing).</li>
          <li><strong>Third-Party Processing:</strong> Payments are handled securely by providers like Stripe and Apple Pay. We do not store your payment data.</li>
          <li><strong>No Refunds:</strong> No refunds are provided except where required by law.</li>
        </ul>

        <h2>5. Intellectual Property</h2>
        <p>All content on our Website and Apps—including logos, designs, text, and software—is owned or licensed by Boggler (Private) Limited. You may not copy, distribute, or create derivative works without our permission.</p>
        <p>Your uploaded content remains yours. By uploading, you grant Boggler and your selected guide(s) a limited license to access and review it for the purpose of delivering services.</p>

        <h2>6. Guide Reviews and Professional Boundaries</h2>
        <ul>
          <li>Guides are mentors, not licensed therapists (unless explicitly stated).</li>
          <li>Feedback provided is for educational and reflective purposes.</li>
          <li>We are not liable for decisions made based on guide feedback.</li>
        </ul>
        <p>If a guide violates our standards, please report the issue to <span onClick={() => window.open("mailto:buck@theboggler.com")}>buck@theboggler.com</span>.</p>

        <h2>7. Termination</h2>
        <p>We reserve the right to suspend or terminate your access for any reason, including violations of these Terms. You may cancel your subscription at any time through your app store or account settings.</p>

        <h2>8. Disclaimers</h2>
        <p>Our services are provided “as-is.” We make no guarantees about accuracy, reliability, or availability. We are not responsible for loss of data, emotional distress, or other damages resulting from use of our services.</p>

        <h2>9. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Boggler (Private) Limited is not liable for indirect, incidental, or consequential damages arising out of or in connection with your use of the services.</p>

        <h2>10. Modifications</h2>
        <p>We may modify these Terms at any time. Changes will take effect when posted to our Website or App. Your continued use of the services after changes means you accept the revised Terms.</p>

        <h2>11. Governing Law</h2>
        <p>These Terms are governed by the laws of Sri Lanka and, where applicable, the United States. Any disputes will be resolved through local courts unless another process is required by applicable law.</p>

        <h2>12. Contact</h2>

        <p>
          <strong>Boggler (Private) Limited</strong><br />
          272b 2/1 High Level Road<br />
          Maharagama 10280, Sri Lanka<br />
          Email: <button onClick={() => window.location.href="mailto:buck@theboggler.com"}>buck@theboggler.com</button>
        </p>

      </div>

    </>
  );
}

export default TermsOfUse;

